// Determine the correct API base URL based on environment
const getApiBaseUrl = () => {
  // If explicitly set via environment variable, use that
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Auto-detect based on current hostname
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Development environment
    return "http://localhost:5000/api";
  } else if (hostname.includes('truesetups.com')) {
    // Production environment - truesetups.com
    return "https://api.stock-ai.link/api";
  } else if (hostname.includes('stock-ai.link')) {
    // Production environment - stock-ai.link
    return "https://api.stock-ai.link/api";
  } else {
    // Fallback to production API
    return "https://api.stock-ai.link/api";
  }
};

const API_BASE = getApiBaseUrl();

export default API_BASE;
